import { useReveal } from "@/hooks/useReveal";

export const Reveal = ({ children, className = "", as: Tag = "div" }) => {
  const ref = useReveal();
  return (
    <Tag ref={ref} className={`reveal ${className}`}>
      {children}
    </Tag>
  );
};
